module.exports = __webpack_public_path__ + "static/media/1002922.fc49ca2b.png";